@if (loading()) {
  <div class="container">
    <p class="basel-empty-page-text">Loading…</p>
  </div>
} @else if (!product()) {
  <div class="container">
    <p class="basel-empty-page-text">This product is not available.</p>
    <p class="return-to-shop"><a class="button" routerLink="/shop">Return to shop</a></p>
  </div>
} @else {
  <div class="single-product-content">
    <div class="container">
      <div class="row product-image-summary-wrap">
        <div class="product-image-summary col-sm-12">
          <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12 product-images">
              @if (salePercent(displayPrice(), selectedVariant()?.compareAtPrice ?? product()!.compareAtPrice); as percent) {
                <div class="product-labels labels-rounded">
                  <span class="onsale product-label">-{{ percent }}%</span>
                </div>
              }
              <div class="woocommerce-product-gallery">
                <figure class="woocommerce-product-gallery__wrapper">
                  <div class="product-image-wrap">
                    <img class="woocommerce-main-image" [src]="mainImage()" [alt]="product()!.name" />
                  </div>
                </figure>
                @if (product()!.images.length > 1) {
                  <div class="thumbnails">
                    @for (url of product()!.images; track url) {
                      <a
                        href="#"
                        [class.is-on]="url === mainImage()"
                        (click)="selectImage(url); $event.preventDefault()"
                      >
                        <img [src]="url" [alt]="product()!.name" />
                      </a>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="col-md-6 col-sm-12 col-xs-12 summary entry-summary">
              <div class="summary-inner">
                <h1 class="product_title entry-title">{{ product()!.name }}</h1>
                <p class="price">
                  @if (selectedVariant()?.compareAtPrice && selectedVariant()!.compareAtPrice! > displayPrice()) {
                    <del>
                      <span class="woocommerce-Price-amount amount">
                        <bdi
                          ><span class="woocommerce-Price-currencySymbol">$</span
                          >{{ selectedVariant()!.compareAtPrice | number: '1.2-2' }}</bdi
                        >
                      </span>
                    </del>
                    <ins>
                      <span class="woocommerce-Price-amount amount">
                        <bdi
                          ><span class="woocommerce-Price-currencySymbol">$</span
                          >{{ displayPrice() | number: '1.2-2' }}</bdi
                        >
                      </span>
                    </ins>
                  } @else {
                    <span class="woocommerce-Price-amount amount">
                      <bdi
                        ><span class="woocommerce-Price-currencySymbol">$</span
                        >{{ displayPrice() | number: '1.2-2' }}</bdi
                      >
                    </span>
                  }
                </p>

                @if ((product()!.options?.length ?? 0) > 0) {
                  <div class="variations" style="margin-bottom: 1rem">
                    @for (option of product()!.options!; track option.id) {
                      <div style="margin-bottom: 0.75rem">
                        <label style="display: block; font-weight: 600; margin-bottom: 0.35rem">{{
                          option.name
                        }}</label>
                        <div style="display: flex; flex-wrap: wrap; gap: 0.4rem">
                          @for (value of option.values; track value.id) {
                            <button
                              type="button"
                              class="button"
                              [style.fontWeight]="selectedOptionValues()[option.id] === value.id ? '700' : null"
                              (click)="selectOptionValue(option.id, value.id)"
                            >
                              {{ value.value }}
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                }

                @if (properties().length) {
                  <div class="woocommerce-product-details__short-description">
                    <ul>
                      @for (row of properties(); track row) {
                        <li>{{ row }}</li>
                      }
                    </ul>
                  </div>
                } @else if (specsHtml()) {
                  <div
                    class="woocommerce-product-details__short-description"
                    [innerHTML]="specsHtml()"
                  ></div>
                }

                <form class="cart" (submit)="$event.preventDefault(); add()">
                  <div class="quantity">
                    <input type="button" value="-" class="minus" (click)="decrement()" />
                    <input type="number" class="input-text qty text" [value]="quantity()" readonly />
                    <input type="button" value="+" class="plus" (click)="increment()" />
                  </div>
                  <button type="submit" class="single_add_to_cart_button button alt">Add to cart</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if (longHtml()) {
      <div class="product-tabs-wrapper">
        <div class="container">
          <div class="woocommerce-Tabs-panel woocommerce-Tabs-panel--description">
            <div [innerHTML]="longHtml()"></div>
          </div>
        </div>
      </div>
    }

    @if (related().length) {
      <div class="container">
        <div class="related products">
          <h2>Related products</h2>
          <div class="products elements-grid row">
            @for (item of related(); track item.id) {
              <app-product-card [product]="item" (add)="addRelated($event)" />
            }
          </div>
        </div>
      </div>
    }
  </div>
}
